import axios from "axios";
import Cookies from "js-cookie";
import router from "@/router";
import { message } from "ant-design-vue";
import store from "@/store"; // 导入 Vuex store

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 50000,
  headers: {},
});

// interceptors request
service.interceptors.request.use(
  (config) => {
    // FormData format default
    if (
      JSON.stringify(config.headers).indexOf(
        "application/json;charset=UTF-8"
      ) === -1 &&
      config.method.toLowerCase() === "post"
    ) {
      const formData = new FormData();
      Object.keys(config.data).forEach((key) => {
        const dataArr = Array.isArray(config.data[key])
          ? config.data[key]
          : Array.of(config.data[key]);
        dataArr.forEach((item) => {
          formData.append(key, (item && item.originFileObj) || item);
        });
      });
      config.data = formData;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// interceptors response
service.interceptors.response.use(
  (response) => {
    // goback to login page if token is invalid
    if (response.status == "401"||response.data.code == "401") {
      Cookies.remove("userDate");
      localStorage.setItem("userName", "");
      localStorage.setItem("userId", "");
      localStorage.setItem("token", "");
      localStorage.setItem("menu", "");
      localStorage.setItem("userInfo", "");
      localStorage.setItem("isLogout", true);
      if (window.__MICRO_APP_ENVIRONMENT__) {
        window.microApp.dispatch({ router: { path: "/login" } });
        router.replace("/login");
      } else {
        router.push("/login");
      }
      return response;
    }
    if (response.data.code == "400") {
      store.commit('HIDE_MENU');
      if (window.__MICRO_APP_ENVIRONMENT__) {
        router.replace({
          path: "/unSubscription",
        });
      } else {
        router.push({
          path: "/unSubscription",
          query: {
            errMsg: response.data.data,
          },
        });
      }
      return response;
    }
    if (response.data.code == "404") {
      if (window.__MICRO_APP_ENVIRONMENT__) {
        router.replace("/404");
      } else {
        router.push("/404");
      }
      return response;
    }
    store.commit('SHOW_MENU');
    return response;
  },
  (error) => {
    if(error.response.status==401){
      Cookies.remove("userDate");
      localStorage.setItem("userName", "");
      localStorage.setItem("userId", "");
      localStorage.setItem("token", "");
      localStorage.setItem("menu", "");
      localStorage.setItem("userInfo", "");
      localStorage.setItem("isLogout", true);
      if (window.__MICRO_APP_ENVIRONMENT__) {
        window.microApp.dispatch({ router: { path: "/login" } });
        router.replace("/login");
      } else {
        router.push("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default service;
